module.exports = __webpack_public_path__ + "img/pr-2.8f15488f.png";